import React from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import RoleGate from 'components/RoleGate';
// @ts-ignore
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
// @ts-ignore
import Online from 'components/Online';
import SchemasWithoutEventTypeIdExistGate from 'components/SchemasWithoutEventTypeIdExistGate';

// Global Constants
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER,
    FIELD_STAFF,
    SUPERVISOR
} from 'components/RoleGate/constants';

// Child Components
// @ts-ignore
import ChecklistTypeModal from 'scenes/Jobs/components/ChecklistTypeModal';
// @ts-ignore
import DocumentSetsRequest from '../../components/DocumentSetsRequest';
// @ts-ignore
import CreateGeneralEventButton from '../../components/CreateGeneralEventButton';
// @ts-ignore
import GeneralEventDuplicateModal from '../../components/GeneralEventDuplicateModal';
// @ts-ignore
import GeneralEventModal from '../../components/GeneralEventModal';
// @ts-ignore
import EventShareModal from '../../components/EventShareModal';
// @ts-ignore
import DocumentSetsTable from './components/DocumentSetsTable';
// @ts-ignore
import DocumentSetsPagination from './components/DocumentSetsPagination';
// @ts-ignore
import DeleteJobModal from './components/DeleteJobModal';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Planner = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Planner"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <SchemasWithoutEventTypeIdExistGate
            FallbackComponent={<Redirect to="/" />}
        >
            <Helmet>
                <title>Planner - {REACT_APP_PROJECT_NAME}</title>
            </Helmet>
            <Online>
                <DocumentSetsRequest />
            </Online>
            <PageTitleAndFilters
                title="Planner"
                Button={
                    <RoleGate
                        requiredRoles={[
                            ADMIN,
                            MANAGER,
                            ASSISTANT_MANAGER,
                            FIELD_STAFF,
                            SUPERVISOR
                        ]}
                    >
                        <CreateGeneralEventButton />
                    </RoleGate>
                }
                searchInputPlaceholder="Search jobs"
                currentEntity
                currentSeason
                variety
                varietyMultiple
                group
                groupMultiple
                schema
                schemaMultiple
                user
                userMultiple
            />
            <PageWrapper top={0} bottom={50}>
                <LoadingGate
                    namespace="DOCUMENT_SETS_LOAD"
                    LoadingComponent={<Loader active inline="centered" />}
                >
                    <ErrorGate namespace="DOCUMENT_SETS_LOAD">
                        <DocumentSetsTable />
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginLeft: 'auto' }}>
                                <TableCountDropdown defaultCount={25} />
                                <DocumentSetsPagination />
                            </div>
                        </div>
                    </ErrorGate>
                </LoadingGate>
            </PageWrapper>
            <CurrentSeasonInProgressGate>
                <DeleteJobModal />
                <GeneralEventDuplicateModal />
            </CurrentSeasonInProgressGate>
            <GeneralEventModal />
            <ChecklistTypeModal />
            <EventShareModal />
        </SchemasWithoutEventTypeIdExistGate>
    </ErrorBoundary>
);

export default Planner;
